<template>
  <div class="modal__wrapper">
    <div class="modal__close">
      <div class="btn" @click="close">
        <Close class="img"/>
      </div>
    </div>
    <div class="modal__header">
      <div class="ttl">
        User Request
      </div>
    </div>
    <div class="modal__body">
      <div class="row">
        <div class="label">Fintech type</div>
        <div class="data">
          <select name="fintech_type_id" class="inpt" v-model="form.fintech_type_id">
            <option :value="null">Select Fintech type</option>
            <option
              v-for="type in fintechTypes" :key="type.id"
              :selected="type.id === form.fintech_type_id"
              :value="type.id"
            >
              {{ type.name }}
            </option>
          </select>
          <div class="error-message" v-if="errors.fintech_type_id">{{ errors.fintech_type_id[0] }}</div>
        </div>
      </div>
      <div class="row">
        <div class="label">License Type</div>
        <div class="data">
          <select name="priority" class="inpt" v-model="form.license_type">
            <option :value="null">Select License Type</option>
            <option
              v-for="type in licenseTypes" :key="type"
              :selected="type === form.license_type"
              :value="type"
            >
              {{ type }}
            </option>
          </select>
          <div class="error-message" v-if="errors.license_type">{{ errors.license_type[0] }}</div>
        </div>
      </div>
      <div class="row">
        <div class="label">Country</div>
        <div class="data">
          <select name="country_id" class="inpt" v-model="form.country_id">
            <option :value="null">Select Country</option>
            <option
              v-for="country in countries" :key="country.id"
              :selected="country.id === form.country_id"
              :value="country.id"
            >
              {{ country.name }}
            </option>
          </select>
          <div class="error-message" v-if="errors.country_id">{{ errors.country_id[0] }}</div>
        </div>
      </div>
      <div class="row">
        <div class="label">Client budget</div>
        <div class="data">
          <select name="client_budget" class="inpt" v-model="form.client_budget">
            <option :value="null">Select Client Budget</option>
            <option
              v-for="(budget, i) in clientBudgets" :key="budget.value"
              :value="budget.value"
            >
              {{ budget.name }}
            </option>
          </select>
          <div class="error-message" v-if="errors.client_budget">{{ errors.client_budget[0] }}</div>
        </div>
      </div>
      <div class="row">
        <div class="label">Status</div>
        <div class="data">
          <select name="priority" class="inpt" v-model="form.status">
            <option :value="null">Select status</option>
            <option
              v-for="status in statuses" :key="status"
              :selected="status === form.status"
              :value="status"
            >
              {{ status }}
            </option>
          </select>
        </div>
      </div>
      <div class="row" v-if="form.created_at">
        <div class="label">Created at</div>
        <div class="data">
          {{ getFormattedDate(form.created_at) }}
        </div>
      </div>
      <div class="row" v-if="form.updated_at">
        <div class="label">Updated at</div>
        <div class="data">
          {{ getFormattedDate(form.updated_at) }}
        </div>
      </div>
      <div class="row row_files">
        <div class="box box_addFiles">
          <div v-if="getUploadedFiles('docs').length" class="content content_many">
            <draggable v-model="upload.docs" tag="div" class="draggable">
            <div v-for="(file, key) in getUploadedFiles('docs')" :key="key" class="file">
              <BlueFile class="img" />
              <div class="btn btn_del" @click="delFile('docs', key, file)"><Close class="img" /></div>
              <div class="btn btn_download" v-if="file.id" v-on:click.stop.prevent="downloadFile(file, 'docs')"><BlueDownload class="img" /></div>
              <div class="desc">{{ file.name }}</div>
            </div>
            </draggable>
            <div class="add">
              <div class="btn" @click="$refs.docs[upload.docs.length - 1].click()"><Close class="img" /></div>
            </div>
          </div>
          <div v-else class="content">
            <div class="choose">
              <div class="btn" @click="$refs.docs[0].click()">License document</div>
            </div>
          </div>
            <input
              v-for="(i, key) in upload.docs"
              :key="key"
              type="file"
              :name="`docs_${key}`"
              class="hide"
              ref="docs"
              @change="addInput($event, 'docs', key)"
            >
        </div>
      </div>
    </div>
    <div class="modal__footer">
      <div class="btn" @click="save">Save</div>
    </div>
  </div>
</template>

<script>
import Close from '../img/Close.vue'
import Tmblr from '../elem/Tmblr.vue'
import BlueFile from '../img/BlueFile.vue'
import draggable from 'vuedraggable'
import BlueDownload from '../img/BlueDownload.vue'

export default {
  components: {
    Close,
    Tmblr,
    BlueDownload,
    BlueFile,
    draggable,
  },
  props: {
    options: {
      type: Object,
      default: null
    }
  },
  data(){
    return{
      countries: [],
      managers: [],
      asystents: [],
      fintechTypes: [],
      priorities: [
        'High (1 hour)',
        'Middle (day)',
        'Low (week)',
      ],
      clientBudgets: [
        {
          name: '< 100 K',
          value: "100000.00"
        },
        {
          name: '< 250 K',
          value: "250000.00"
        },
        {
          name: '< 500 K',
          value: "500000.00"
        },
        {
          name: '< 1 M',
          value: "1000000.00"
        },
        {
          name: '< 2 M',
          value: "2000000.00"
        },
        {
          name: '< 5 M',
          value: "5000000.00"
        },
        {
          name: '< 10 M',
          value: "10000000.00"
        },
        {
          name: '> 10 M',
          value: "9999999999.00"
        },
      ],
      statuses: [
        'Active',
        'Push',
        'Lost',
        'Close win',
        'Not active',
        'Clarification needed',
        'Hold',
        'Closed'
      ],
      form: {
        country_id: null,
        status: null,
        client_budget: null,
        fintech_type_id: null,
        license_type: null,
        user_id: null,
      },
      licenseTypes: [
        "Bank",
        "EMI",
        "SEMI",
        "API",
        "SPI",
        "MSB",
        "MIP",
        "KIP",
        "MSO",
        "PSP (AISP, PISP)",
        "FSP",
        "Money service/Remittee",
        "SRO",
        "VC",
        "Fund",
        "Asset management",
        "Broker/Dealer/Forex",
        "MPI",
        "SPI",
        "ECSP",
        "Fintech",
        "VASP/DASP/CASP",
        "Gambling",
        "Other",
      ],
      errors: {},
      upload: {
        docs: [{ name: null }],
      }
    }
  },
  computed: {
    isEdit () {
      return this.options && this.options.id && this.options.form
    }
  },
  async created () {
    if(this.isEdit){
      await this.getUserRequest()
      await this.getDocs()
    }

    await this.getCountries()
    await this.getFintechTypes()
  },
  mounted(){
    if(!this.isEdit){
      this.form.user_id = this.options.user.id
    }
  },
  methods: {
    getFormattedDate(value){
      if(value){
        const date = new Date(value);
        
        const formattedDate = date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        
        return formattedDate;
      }
      
      return ''
    },
    async getDocs () {
      const that = this
      const id = this.options.id
      
      if(id){
        await axios.get('admin/user-requests/' + id + '/get-file/docs')
        .then((response) => {
          let docsData = response.data

          if(docsData.length > 0) {
            that.upload.docs = docsData.map((el) => {
              return {
                id: el.id,
                uuid: el.uuid,
                name: el.name,
                type: 'server',
                url: el.original_url,
                order: el.order
              }
            })
          }
        })
        .catch((errors) => {
          console.dir(errors)
        })
      }
    },
    getUploadedFiles(el) {
      return this.upload[el].filter(e => e.name !== null)
    },
    delFile(name, key, file) {
      if (this.upload[name].length > 1) {
        this.upload[name].splice(key, 1)
      } else {
        this.upload[name][0].name = null
      }

      if(file.id && this.options.id){
        axios.post('admin/user-requests/' + this.options.id +'/delete-file', {
        collection: name,
        media_id: file.id,
      })
        .then(function () {
          
        })
        .catch(function (error) {
          console.log(error);
        })
      }
    },
    addInput(event, name, key) {
      if (this.$refs[name][key].files.length) {
        const file_name = this.$refs[name][key].files[0].name
        if (this.getUploadedFiles(name).some(e => e.name == file_name)) {
          this.$noty.error('Error! A file with this name has already been added.')
          return false
        }

        const extension = this.$refs[name][key].files[0].name.split('.').pop()
        const availableExtensionsArr = ['jpg', 'jpeg', 'png', 'txt', 'pdf', 'doc', 'docx', 'xlsx']
        if (!availableExtensionsArr.includes(extension.toLowerCase())) {
          this.$noty.error('You can upload files only with these extensions: ' + availableExtensionsArr.join(', '))
          return false
        }

        if (this.$refs[name][key].files[0].size / 1024 / 1024 > 10) {
          this.$noty.error('File is too large. Maximum - 10MB.')
          return false
        }

        this.upload[name] = this.upload[name].filter(e => e.name !== null)
        if (this.$refs[name].length < 10) {
          this.upload[name].push({ name: file_name, file: event.target.files[0]})
        } else {
          this.$noty.error('Maximum - 10 files')
        }
      }
    },
    downloadFile(file, type) {
      const id = this.options.id
      if(file.url){
        this.openFile(file.url)
      }
      else if(id){
        axios.post('admin/user-requests/' + id +'/get-file-link', {
        collection: type,
        media_id: file.id,
      })
        .then(function (response) {
          if (response.data) {
            const url = response.data
            var fileURL = response.data;
            this.openFile(fileUrl);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
      }
    },
    openFile(url){
      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.setAttribute('target', '_blank')
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    async getUserRequest(){
      const that = this
      await axios.get('admin/user-requests/' + this.options.id).then(function (response) {
        that.form = response.data
      }).catch(function (error) {
        console.log(error);
      })
	  },
    async getCountries () {
      await axios.get('admin/data/countries')
      .then(({data}) => {
        this.countries = data
      })
      .catch((error) => {
        console.log(error);
      })
    },
    async getFintechTypes(){
      await axios.get('admin/data/fintech-types')
        .then(({ data }) => {
          this.fintechTypes = data
        })
        .catch(err => console.dir(err))
    },
    async save(){
      this.errors = {};
      
      let url = process.env.VUE_APP_BACKEND_API_URL + 'admin/user-requests'

      if (this.isEdit) {
        url += '/' + this.options.id
      }

      await axios.post(url, this.form).then((response) => {
        this.close();
      
        this.processFiles(response.data.userRequest.id);
      
        if(this.isEdit){
          this.$store.dispatch('editItemFromTable', {
            id: this.options.id,
            table: this.options.table,
            actionType: this.options.actionType,
          });
        } else{
          this.$store.dispatch('createItemInTable', {
            table: this.options.table,
            actionType: this.options.actionType,
          });
        }
      }).catch((error) => {
        if(error.response && error.response.data){
          this.errors = error.response.data.errors || {};
      
          this.$noty.error("Validation error occurred. Please check the fields.");
        } else {
          console.error("Unknown error:", error);
          
          this.$noty.error("An unexpected error occurred.");
        }
      });
    },
    processFiles(id){
      let data = new FormData()
      const uploadKeys = Object.keys(this.upload)

      for (let z = 0; z < uploadKeys.length; z++) {
        const key = uploadKeys[z]
        for (let i = 0; i < this.upload[key].length; i++) {
          if (this.upload[key][i].name !== null) {
            let f = {}
            if (this.upload[key][i].type == 'server') {
              f = JSON.stringify(this.upload[key][i])
            } else {
              data.append(key + '_names[' + i + ']', this.upload[key][i].name)
              f = this.upload[key][i].file
            }
            data.append(key + '[' + i + ']', f)
          }
        }
      }
      
      axios.post('admin/user-requests/' + id + '/files', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then((response) => {
        this.close()
      })
      .catch((errors) => {
        console.dir(errors)
      })
    },
    close() {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  &__wrapper {
    width: 40rem;
  }

  &__header {
    padding: 2.5rem 0.75rem 1.5rem;
  }

  &__body {
    flex-direction: column;
    align-content: flex-start;

    .row {
      width: 100%;
      display: flex;
      align-items: center;
      padding: .25rem 0;
      margin: .25rem 0 0;

      .label {
        min-width: 10rem;
        padding-right: .75rem;
        font-weight: bold;
        max-width: 160px;
      }

      .data {
        flex-grow: 1;

        .inpt {
          width: 100%;
          color: #000000;

          &__ta {
            height: 7rem;
          }
        }
        .btn {
          padding: 0.5rem;
          background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
          border-radius: 6px;
          color: #fff;
          font-size: 13px;
        }
        .delete-btn{
          margin-left: auto;
          width: 24px;
          height: 24px;
          background-color: #B03636;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          svg{
            fill: #fff;
            max-width: 16px;
            max-height: 16px;
          }
        }
      }

      &__price {
        .data {
          display: flex;

          input {
            margin-right: .75rem;
          }

          select {
            color: white;
            background-color: var(--c_more-black);
            padding: .25rem .5rem;
            border-radius: 6px;
          }
        }
      }
    }
    .row{
      &_files {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 8px;

        .box_addFiles {
          width: 30%;
          //width: calc(50% - .75rem);
          //margin: .75rem 0;
          //padding: 1rem 1.75rem;
          //background: #22252B;
          box-shadow: 0px 12px 23px rgba(62, 73, 84, 0.04);
          display: flex;
          flex-direction: column;

          .ttl {
            padding-bottom: .25rem;
          }

          .separ {
            width: 3rem;
            height: .25rem;
            background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
            box-shadow: 0px 12px 23px rgba(62, 73, 84, 0.04);
            border-radius: 14px;
            margin: .25rem 0;
          }

          .content {
            padding: 1rem;
            flex-grow: 1;
            //margin-top: 1rem;
            border: 1px dashed #1763fb;
            box-sizing: border-box;
            filter: drop-shadow(0px 12px 23px rgba(62, 73, 84, 0.04));
            border-radius: 14px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            .choose {
              text-align: center;

              .btn {
                padding: 0.5rem;
                background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
                border-radius: 6px;
                color: #fff;
                font-size: 13px;
              }

              .desc {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.3);
              }
            }

            &_many {
              flex-wrap: wrap;
              align-items: flex-start;
              justify-content: space-between;
              padding: 0.75rem 6px;

              .draggable {
                display: flex;
                padding: 0;
                flex-wrap: wrap;
              }

              .file {
                position: relative;
                text-align: center;
                width: 4.5rem;
                max-width: 4.5rem;

                svg.img {
                  width: 3rem;
                  height: 3rem;
                  margin: 0 auto;
                  cursor: pointer;
                  fill: #1763fb;
                  path{
                    fill: #1763fb;
                  }
                }
                .btn {
                  &_del {
                    position: absolute;
                    top: 0;
                    right: 1rem;
                    width: 1.25rem;
                    height: 1.25rem;
                    border-radius: 50%;
                    background-color: #B03636;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    svg.img {
                      width: 40%;
                      height: 40%;
                    }
                  }

                  &_download {
                    position: absolute;
                    top: 1.7rem;
                    right: 1rem;
                    width: 1.25rem;
                    height: 1.25rem;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    svg.img {
                      width: 90%;
                      height: 90%;
                    }
                  }
                }

                .desc {
                  font-size: 10px;
                  color: #333333;
                  word-break: break-word;
                }
              }

              .add {
                text-align: center;
                width: 2.5rem;
                max-width: 2.5rem;

                .btn {
                  width: 2.5rem;
                  height: 2.5rem;
                  border-radius: 50%;
                  background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  svg.img {
                    width: 45%;
                    height: 45%;
                    transform: rotate(45deg);
                  }
                }

                .desc {
                  font-size: 12px;
                  color: rgba(255, 255, 255, 0.3);
                }
              }
            }
          }
        }
      }
    }
  }
  &__footer {
    padding: 1rem 1.5rem 1.5rem;
  }
  textarea{
    height: 5rem;
  }
}
.gap-12{
  gap: 12px;
}

.error-message{
  color: red;
}
</style>
